export default __webpack_public_path__ + "static/media/vishal-ludhrani.95cc9fee.jpeg";